module.exports = "/_next/static/images/OgEngineering-6fc45870b46d9bb62d866eb94a0a5016.jpeg";